import * as basicScroll from "basicscroll";

export default function() {
  const fadeInBoxes = [];
  const fadeInBoxes_lower = [];
  const yBoxes = [];

  // -- Fade Up
  document.querySelectorAll(".js-fadeIn").forEach((elem, i) => {
    // Get the timing from the data attribute.
    // You can also hard-code the timing, but for the demo it's easier this way.
    const timing = elem.getAttribute("data-timing");
    const transform = elem.getAttribute("data-transform");

    // Crate an instance for the current element and store the instance in an array.
    // We start the animation later using the instances from the array.
    fadeInBoxes.push(
      basicScroll.create({
        elem: elem,
        from: "middle-bottom",
        to: "middle-middle",
        direct: true,
        props: {
          "--transform": {
            from: `${10 * transform}px`,
            to: "0",
            timing: timing
          },
          "--opacity": {
            from: 0.01,
            to: 0.99
          }
        }
      })
    );
  });
  // -- Fade Up -lower
  document.querySelectorAll(".js-fadeIn--lower").forEach((elem, i) => {
    // Get the timing from the data attribute.
    // You can also hard-code the timing, but for the demo it's easier this way.
    const timing = elem.getAttribute("data-timing");
    const transform = elem.getAttribute("data-transform");

    // Crate an instance for the current element and store the instance in an array.
    // We start the animation later using the instances from the array.
    fadeInBoxes_lower.push(
      basicScroll.create({
        elem: elem,
        from: "bottom-bottom",
        to: "middle-middle",
        direct: true,
        props: {
          "--transform": {
            from: `${10 * transform}px`,
            to: "0",
            timing: timing
          },
          "--opacity": {
            from: 0.01,
            to: 0.99
          }
        }
      })
    );
  });
  // -- Ybox (just up and down por favor)
  document.querySelectorAll(".js-yBox").forEach((elem, i) => {
    // Get the timing from the data attribute.
    // You can also hard-code the timing, but for the demo it's easier this way.
    const timing = elem.getAttribute("data-timing");
    const transform = elem.getAttribute("data-transform");

    // Crate an instance for the current element and store the instance in an array.
    // We start the animation later using the instances from the array.
    yBoxes.push(
      basicScroll.create({
        elem: elem,
        from: "middle-bottom",
        to: "bottom-top",
        direct: true,
        props: {
          "--transform": {
            from: `${10 * transform}px`,
            to: "0",
            timing: timing
          }
        }
      })
    );
  });

  window.addEventListener("load", function() {
    fadeInBoxes.forEach(easeBox => easeBox.start());
    fadeInBoxes_lower.forEach(easeBox => easeBox.start());
    yBoxes.forEach(easeBox => easeBox.start());
  });
}
